
    <div class="w-full bg-white px-4 md:px-8" >
    <!-- Header -->
    <div class="flex flex-row  justify-between items-center py-3 border-b">

        <!-- Title -->
        <div class="w-full flex items-center">
            <arrow-back></arrow-back>
            <div>
                <div class="text-2xl font-extrabold leading-7 tracking-tight sm:leading-10 md:text-4xl">Documentos Oficiales</div>
                <div class="ml-0.5 font-medium text-secondary"></div>
            </div>
        </div>
        
    </div>
        

    <div class="flex flex-col md:flex-row items-center justify-between w-full gap-0 md:gap-2 mt-4">
        <mat-form-field class="fuse-mat-dense flex-1 w-full md:w-auto">
            <mat-label>Fecha Inicio</mat-label>
            <input matInput id="fechaInicio" type="date" name="fechaInicio" [(ngModel)]="paramsDocumentos.fechaInicio">
        </mat-form-field>

        <mat-form-field class="fuse-mat-dense flex-1 w-full md:w-auto">
            <mat-label>Fecha Fin</mat-label>
            <input matInput id="fechaFin" type="date" name="fechaFin"  [(ngModel)]="paramsDocumentos.fechaFin">
        </mat-form-field>

        <mat-form-field class="fuse-mat-dense flex-1 w-full md:w-auto">
            <mat-label>Sección</mat-label>
            <mat-select name="seccion" id="seccion" [(ngModel)]="paramsDocumentos.seccion">
                <mat-option [value]="todas">Todas</mat-option>
                <mat-option *ngFor="let s of secciones" [value]="s.tipologiaId">
                    {{ s.descripcion }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <button (click)="filtrar()" class="flex-1" mat-flat-button [color]="'primary'" class="rounded-full w-full md:w-auto">
            Filtrar
        </button>
    </div>

    <div class="bg-card rounded-2xl shadow mt-4 p-4">
        <table mat-table [dataSource]="dataSource" class="w-full table-auto">
            <!-- ID Column -->
            <ng-container matColumnDef="id">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                    ID
                </th>
                <td mat-cell *matCellDef="let doc" class="whitespace-nowrap pr-6 text-sm text-secondary font-medium" >
                   <span class="font-medium leading-5">{{doc.documentoGeneradoUuid}}</span>
                </td>
            </ng-container>

            <!-- tipoDocumento Column -->
            <ng-container matColumnDef="tipoDocumento">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                    Tipo
                </th>
                <td mat-cell *matCellDef="let doc" 
                    class="whitespace-nowrap pr-6 text-sm text-secondary font-medium"> 
                    {{ doc.tipoDocumentoTexto }}
                </td>
            </ng-container>

            <!-- seccion Column -->
            <ng-container matColumnDef="seccion">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                    Sección
                </th>
                <td mat-cell *matCellDef="let doc" class="whitespace-nowrap pr-6 text-sm text-secondary font-medium" >
                     <status-sticker [estado]="doc.seccion?.descripcion" [color1]="doc.seccion?.valor1" [color2]="doc.seccion?.valor2"></status-sticker>
                </td>
            </ng-container>

            <!-- estado Column -->
            <ng-container matColumnDef="estado">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                    Estado
                </th>
                <td mat-cell *matCellDef="let doc" class="whitespace-nowrap pr-6 text-sm text-secondary font-medium" >
                    <span  class="px-2 rounded-full text-sm font-bold text-white"
                        [ngStyle]="{
                            'background-color': doc.estado.valor1, 
                        }">
                            {{doc.estado.descripcion}}
                    </span>
                </td>
            </ng-container>

            <!-- fechaGeneracion Column -->
            <ng-container matColumnDef="fechaGeneracion">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                    Fecha Generación
                </th>
                <td mat-cell *matCellDef="let doc" class="whitespace-nowrap pr-6 text-sm text-secondary font-medium" >
                     {{doc.fechaInicioVigencia | date: 'mediumDate'}}
                </td>
            </ng-container>

            <!-- Vencimiento Column -->
            <ng-container matColumnDef="vencimiento">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                    Vencimiento
                </th>
                <td mat-cell *matCellDef="let doc" class="whitespace-nowrap pr-6 text-sm text-secondary font-medium" >
                     {{doc.fechaFinVigencia | date: 'mediumDate'}}
                </td>
            </ng-container>

            <!-- link Column -->
            <ng-container matColumnDef="link">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                    
                </th>
                <td mat-cell *matCellDef="let doc" class="whitespace-nowrap pr-6 text-sm text-secondary font-medium" >
                    <button (click)="abrirDetalleDocumento(doc.documentoGeneradoUuid)" class="whitespace-nowrap pr-6 text-sm ">
                        <mat-icon [svgIcon]="'heroicons_solid:arrow-top-right-on-square'" ></mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="tableColumns" class="bg-slate-100 h-12"></tr>
            <tr mat-row *matRowDef="let row; columns: tableColumns" class="order-row h-10 border-y border-gray-200"></tr>
            
        </table>
        <mat-paginator [length]="totalItems" [pageSize]="pageSizes" [hidePageSize]="true"></mat-paginator>
    </div>
</div>

